import { TGetShopItem } from './interfaces';

export const getShopItem: TGetShopItem = ({
  t,
  permissions,
  openStartSeanceModal,
  selectedHostsIds,
  hosts,
}) => {
  const selectedHosts = hosts?.filter((host) =>
    selectedHostsIds?.includes(host.id)
  );

  return !permissions?.has('payment_create')
    ? null
    : {
        key: 'shop',
        text: t('host.ctx.tariff'),
        iconName: 'ClockIcon',
        disabled: ({ in_service, locked, client_sessions }) => {
          if (selectedHostsIds && selectedHostsIds?.length > 1)
            return (
              selectedHosts?.some((host) => host.in_service) ||
              selectedHosts?.some((host) => host.locked) ||
              selectedHosts?.some(
                (host) => host.client_sessions?.[0]?.postpaid
              ) ||
              !selectedHosts?.every(
                (host) => host.group_id === selectedHosts[0].group_id
              ) ||
              selectedHosts.some((host) => host.user !== null)
            );

          return (
            in_service ||
            locked ||
            selectedHostsIds?.length === 0 ||
            Boolean(client_sessions?.[0]?.postpaid)
          );
        },
        onClick: openStartSeanceModal,
      };
};
